export default "__VITE_ASSET__b1b6d7f6__"